import React from 'react'
import { connect } from 'react-redux'
import { Divider, Dropdown } from 'antd'
import { Link } from 'react-router-dom'
import { getGravatarForHeader } from 'helpers'
import constants from '../../../../constants'
import 'react-sliding-pane/dist/react-sliding-pane.css'
import style from './style.module.scss'

@connect(({ user, settings }) => ({ user, settings }))
class ProfileMenu extends React.Component {
  logout = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'user/LOGOUT',
    })
  }

  handleGoToBilling = e => {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch({
      type: 'user/GET_BILLING_DATA',
      onComplete: this.takeUserToSubscriptionURL,
    })
  }

  handleShowFeedbackModal = (showFeedback = '') => {
    const { dispatch } = this.props
    dispatch({
      type: 'user/SHOW_USER_FEEBACK',
      payload: { showFeedback },
    })
  }

  takeUserToSubscriptionURL = ({ error, cancelled, data }) => {
    if (!error && !cancelled && data.data) {
      if (data.data.link !== undefined) window.open(data.data.link, '_blank')
    }
  }

  render() {
    const { user, pathname } = this.props

    const menu = constants.avoidOnboardingActionsRoutes.some(path => pathname.includes(path)) ? (
      <></>
    ) : (
      <div className={style.overlay}>
        <div className={style.logoutHello}>
          <div className={style.topLinkHello}>
            Hello, <div className={style.userNameSpan}>{user.name}</div>
          </div>
        </div>

        <Divider
          className={style.dividerCustom}
          style={{ margin: '6px 0px 5px ', width: 'auto' }}
        />

        <a
          href="https://www.cometchat.com/updates#pro"
          target="_blank"
          tabIndex="-1"
          rel="noopener noreferrer"
          id="changelog"
          style={{ marginBottom: '0px' }}
        >
          <div className={style.logout}>
            <div className={style.topLink} style={{ textAlign: 'left' }}>
              What&#39;s New?
            </div>
          </div>
        </a>

        <Link to="/settings">
          <div className={style.logout}>
            <div className={style.topLink}>
              <React.Fragment>Account Settings</React.Fragment>
            </div>
          </div>
        </Link>

        <Divider
          className={style.dividerCustom}
          style={{ margin: '6px 0px 5px ', width: 'auto' }}
        />

        <a role="button" tabIndex="-1" onKeyPress={this.logout} onClick={this.logout}>
          <div className={style.logout}>
            <div className={style.topLink}>
              <React.Fragment>Log Out</React.Fragment>
            </div>
          </div>
        </a>
      </div>
    )

    return (
      <div style={{ maxWidth: '300px' }}>
        <Dropdown overlay={menu} trigger={['click']}>
          <div
            className={`${style.welcomeHeaderAvatarWrapper}  ${
              constants.avoidOnboardingActionsRoutes.some(path => pathname.includes(path))
                ? `${style.newUser}`
                : ''
            } `}
          >
            <img
              className={style.welcomeHeaderAvatar}
              src={getGravatarForHeader()}
              alt="userAvatar"
            />
          </div>
        </Dropdown>
      </div>
    )
  }
}

export default ProfileMenu
